(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-ui/outcome/assets/javascripts/distributed-outcome.js') >= 0) return;  svs.modules.push('/components/lb-ui/outcome/assets/javascripts/distributed-outcome.js');
"use strict";


const clx = svs.components.lbUtils.clx;
const _React = React,
  useRef = _React.useRef,
  useEffect = _React.useEffect;
const DistributedOutcome = _ref => {
  let ariaLabel = _ref.ariaLabel,
    branding = _ref.branding,
    className = _ref.className,
    dataTestId = _ref.dataTestId,
    distribution = _ref.distribution,
    isBestBetOutcome = _ref.isBestBetOutcome,
    isDisabled = _ref.isDisabled,
    isResult = _ref.isResult,
    shouldShowResult = _ref.shouldShowResult,
    sign = _ref.sign;
  const outcomeClassNames = clx('pg_outcome pg_outcome__distributed', className, {
    'pg_outcome--disabled': isDisabled,
    'pg_outcome--selected': distribution > 0,
    'pg_outcome--correct': shouldShowResult && isResult,
    'pg_outcome--best-bet': isBestBetOutcome,
    'pg_outcome--correct-selected': shouldShowResult && isResult && isBestBetOutcome,
    'pg_outcome--correct-not-selected': shouldShowResult && isResult && !isBestBetOutcome,
    'pg_outcome__distributed--not-full': distribution < 100,
    ["pg_outcome--".concat(branding)]: branding
  });
  const outcomeRef = useRef();
  useEffect(() => {
    if (distribution) {
      outcomeRef.current.style.setProperty('--distribution', "".concat(distribution, "%"));
    }
  }, [distribution]);
  return React.createElement("span", {
    "aria-label": ariaLabel,
    className: outcomeClassNames,
    "data-testid": dataTestId,
    ref: outcomeRef
  }, React.createElement("span", {
    className: "pg_outcome__sign"
  }, sign));
};
setGlobal('svs.components.lbUi.outcome.DistributedOutcome', DistributedOutcome);

 })(window);